<style scoped>
  .info-dashboard {font-weight: bold !important; width: 100%}
</style>

<template>
  <section class="container" >
    <div class="columns">
      <div class="column">
        <portal-perfil/>
      </div>

      <div class="column is-4 has-text-centered">
        <img src="../assets/images/logo_piller.png" v-if="$sistema.nome() === 'PILLER'"/>        
      </div>

    </div>

    <div class="columns">
      <div class="column">
        <div class="columns">
          <div class="column">
            <quadro-moeda texto="Meta" :loading="loading" :valor="meta.META"/>
          </div>
          <div class="column">
            <quadro texto="Novos clientes" :loading="loading" :valor="meta.NOVOS_CLIENTES"/>
          </div>
          <div class="column">
            <quadro texto="Pedidos" :loading="loading" :valor="meta.NOVOS_PEDIDOS"/>
          </div>
          <div class="column">
            <quadro-moeda texto="Valor Pedidos" :loading="loading" :valor="meta.REALIZADO"/>
          </div>
          <div class="column">
            <quadro-moeda texto="Valor faturado" :loading="loading" :valor="meta.VALOR_FATURADO"/>
          </div>
        </div>

      </div>

      <div class="column is-4">
        <ranking-produto />
      </div>
    </div>

  </section>
</template>

<script>
  import {auth} from '../mixins/auth'
  import Quadro from '../components/Quadro'
  import QuadroMoeda from '../components/QuadroMoeda'
  import Grafico from '../components/Grafico'
  import RankingProduto from '../components/RankingProduto'
  import {mapActions} from 'vuex'

  export default {
    components: {Quadro, QuadroMoeda, Grafico, RankingProduto},
    mixins: {auth},
    created () {
      this.buscarMetas()
      this.buscarMenuSistema()
      this.carregarRegrasComercias()
    },
    data () {
      return {
        loading: false,
        meta: {}
      }
    },
    methods: {
      ...mapActions(['setRegrasComerciais', 'setMenu']),
      buscarMetas () {
        this.loading = true
        this.$http.get(this.$URL.METAS.MES_CORRENTE, this.$header()).then(res => {
          this.meta = res.body
          this.loading = false
        }, res => { this.mensagemFalha(res) })
      },
      buscarMenuSistema () {
        this.loading = true
        this.$http.get(this.$URL.MENU_SISTEMA, this.$header()).then(res => {
          this.loading = false
          this.setMenu(res.body)
        }, res => {
          this.mensagemFalha(res)
        })
      },
      carregarRegrasComercias () {
        this.loading = true
        this.$http.get(this.$URL.REGRA_COMERCIAL, this.$header()).then(res => {
          this.loadingForm = false
          this.setRegrasComerciais(res.body)
        }, res => {
          this.mensagemFalha(res)
        })
      },
      mensagemFalha (res) {
        this.toast(res)
        this.loading = false
      },
      toast (res) {
        let msg = res.body.message ? res.body.message : res.body
        let tipo = 'is-danger'
        switch (res.status) {
          case 401:
            tipo = 'is-danger'
            msg = 'Token inválido! Favor logar novamente.'
            break
          case 0:
          case 404:
            tipo = 'is-warning'
            msg = 'Ops! Nosso servidor está offline, tente novamente mais tarde.'
            break
          case 422:
            tipo = 'is-danger'
            break
          case 500:
            tipo = 'is-danger'
            msg = 'Ocorreu um problema na conexão com o servidor, caso persista favor contactar o administrator do sistema para uma análise mais detalhada.'
            break
          case 200:
            tipo = 'is-info'
            break
          case 201:
            tipo = 'is-success'
            break
        }
        this.$toast.open({
          message: msg,
          type: tipo,
          duration: 4 * 1000
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/Dashboard.vue